import { RiCloseFill, RiLightbulbLine } from "@remixicon/react";
import toast from "react-hot-toast";

const tipToast = (text: string) => {
  return toast(
    (t) => (
      <div className="flex gap-2 items-center">
        <p className="max-w-sm">{text}</p>
        <RiCloseFill size={24} onClick={() => toast.dismiss(t.id)} />
      </div>
    ),
    {
      duration: Infinity,
      icon: (
        <div className="bg-yellow-300 text-white rounded-full p-1">
          <RiLightbulbLine size={14} />
        </div>
      ),
      style: {
        maxWidth: "500px",
      },
    }
  );
};

export default tipToast;
